'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function AbstractIterator(db) {
  if (typeof db !== 'object' || db === null) {
    throw new TypeError('First argument must be an abstract-leveldown compliant store');
  }

  this.db = db;
  this._ended = false;
  this._nexting = false;
}

AbstractIterator.prototype.next = function (callback) {
  var _this = this;

  // In callback mode, we return `this`
  var ret = this;

  if (callback === undefined) {
    ret = new Promise(function (resolve, reject) {
      callback = function callback(err, key, value) {
        if (err) reject(err);else if (key === undefined && value === undefined) resolve();else resolve([key, value]);
      };
    });
  } else if (typeof callback !== 'function') {
    throw new Error('next() requires a callback argument');
  }

  if (this._ended) {
    this._nextTick(callback, new Error('cannot call next() after end()'));

    return ret;
  }

  if (this._nexting) {
    this._nextTick(callback, new Error('cannot call next() before previous next() has completed'));

    return ret;
  }

  this._nexting = true;

  this._next(function (err) {
    _this._nexting = false;

    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    callback.apply(void 0, [err].concat(rest));
  });

  return ret;
};

AbstractIterator.prototype._next = function (callback) {
  this._nextTick(callback);
};

AbstractIterator.prototype.seek = function (target) {
  if (this._ended) {
    throw new Error('cannot call seek() after end()');
  }

  if (this._nexting) {
    throw new Error('cannot call seek() before next() has completed');
  }

  target = this.db._serializeKey(target);

  this._seek(target);
};

AbstractIterator.prototype._seek = function (target) {};

AbstractIterator.prototype.end = function (callback) {
  var promise;

  if (callback === undefined) {
    promise = new Promise(function (resolve, reject) {
      callback = function callback(err) {
        if (err) reject(err);else resolve();
      };
    });
  } else if (typeof callback !== 'function') {
    throw new Error('end() requires a callback argument');
  }

  if (this._ended) {
    this._nextTick(callback, new Error('end() already called on iterator'));

    return promise;
  }

  this._ended = true;

  this._end(callback);

  return promise;
};

AbstractIterator.prototype._end = function (callback) {
  this._nextTick(callback);
};

AbstractIterator.prototype[Symbol.asyncIterator] = /*#__PURE__*/_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var kv;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;

        case 1:
          _context.next = 3;
          return _awaitAsyncGenerator(this.next());

        case 3:
          _context.t0 = kv = _context.sent;
          _context.t1 = undefined;

          if (!(_context.t0 !== _context.t1)) {
            _context.next = 10;
            break;
          }

          _context.next = 8;
          return kv;

        case 8:
          _context.next = 1;
          break;

        case 10:
          _context.prev = 10;

          if (this._ended) {
            _context.next = 14;
            break;
          }

          _context.next = 14;
          return _awaitAsyncGenerator(this.end());

        case 14:
          return _context.finish(10);

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, this, [[0,, 10, 15]]);
})); // Expose browser-compatible nextTick for dependents

AbstractIterator.prototype._nextTick = require('./next-tick');
module.exports = AbstractIterator;